import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    component: () => import("../views/IndexView.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../views/ProductView.vue"),
  },
  {
    path: "/product/:productId",
    name: "productDetails",
    component: () => import("../views/ProductDetailsView.vue"),
  },
  {
    path: "/product/business/:type",
    name: "productBusiness",
    component: () => import("../views/ProductBusiness.vue"),
  },
  {
    path: "/example",
    name: "example",
    component: () => import("../views/ExampleView.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/NewsView.vue"),
  },
  {
    path: "/news/newsId/:newsId",
    name: "newsDetails",
    component: () => import("../views/NewsDetailsView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/development",
    name: "development",
    component: () => import("../views/Development.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/Contact.vue"),
  },
];

const router = new VueRouter({
  //mode: "history",
  routes,
  // scrollBehavior(to, form, savedPosition) {
  //   return { top: 0 };
  // },
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        const checkElement = () => {
          const element = document.querySelector(to.hash);
          // 假设导航栏的类名为 header-wrapper，可根据实际情况修改
          const navbar = document.querySelector(".header-wrapper");
          const navbarHeight = navbar ? navbar.offsetHeight : 0;

          if (element) {
            const rect = element.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetTop = rect.top + scrollTop - navbarHeight;

            resolve({
              top: targetTop,
              behavior: "smooth",
            });
          } else {
            if (checkElement.attempts < 10) {
              checkElement.attempts++;
              setTimeout(checkElement, 200);
            } else {
              resolve({ top: 0 });
            }
          }
        };
        checkElement.attempts = 0;
        checkElement();
      });
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.afterEach((to) => {
  if (!to.hash) {
    window.scrollTo(0, 0);
  }
});
export default router;
